import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import {
  lateralBottomMenu,
  lateralMenu
} from '../../constants/lateralMenu';

import classes from './LateralMenu.module.css';

const LateralMenu = props => {
  const [itemSelected, setItemSelected] = useState('store');

  useEffect(() => {
    const url = window.location.pathname.split('/');
    if (url[1]) {
      setItemSelected(url[1]);
      props.changeSelectedItem(url[1]);
    }
  }, []);

  const changeItemSelectedHandler = itemSelected => () => {
    setItemSelected(itemSelected);
    props.changeSelectedItem(itemSelected);
  };

  const { t } = useTranslation(['lateralMenu']);
  return (
    <div className={classes.lateralMenuContainer}>
      {lateralMenu.map(item =>
        item.externalLink ? (
          <Button
            onClick={changeItemSelectedHandler(item.linkOption)}
            component="a"
            to={item.link}
            target={'_blank'}
            key={item.text}
            className={
              itemSelected === item.linkOption
                ? classes.itemSelected
                : classes.item
            }
          >
            <figure
              className={classes.iconAvatar}
              style={{ width: item.width, height: item.height }}
            >
              <img src={item.icon} className={classes.img} />
            </figure>
            <span className={classes.itemText}>{t(item.text)}</span>
          </Button>
        ) : (
          <Button
            onClick={changeItemSelectedHandler(item.linkOption)}
            component={Link}
            to={item.link}
            key={item.text}
            className={
              itemSelected === item.linkOption
                ? classes.itemSelected
                : classes.item
            }
          >
            <figure
              className={classes.iconAvatar}
              style={{ width: item.width, height: item.height }}
            >
              <img src={item.icon} className={classes.img} />
            </figure>
            <span className={classes.itemText}>{t(item.text)}</span>
          </Button>
        )
      )}
      <Divider className={classes.divider} />
      <div className={classes.bottomMenu}>
        {lateralBottomMenu.map(item => (
          <Button
            onClick={changeItemSelectedHandler(item.linkOption)}
            component={Link}
            to={item.link}
            key={item.text}
            className={
              itemSelected === item.linkOption
                ? classes.itemSelected
                : classes.item
            }
          >
            <figure
              className={classes.iconAvatar}
              style={{ width: item.width, height: item.height }}
            >
              <img src={item.icon} className={classes.img} />
            </figure>
            <span className={classes.itemText}>{t(item.text)}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

LateralMenu.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeSelectedItem: PropTypes.function
};

export default LateralMenu;
